import { Box, Group, Stack } from '@mantine/core';
import { IconSkeleton, TextSkeleton } from '@repo/foundations';
import { toInteger } from 'lodash-es';
import { memo } from 'react';

export const IntegrationGroupsSkeleton = memo(() => (
	<Box>
		<Stack spacing="sm" p="sm">
			{Array.from({ length: 5 }).map((_, index) => (
				<Group key={toInteger(index)} spacing="xs" noWrap>
					<IconSkeleton />
					<TextSkeleton width="100%" height="20px" />
				</Group>
			))}
		</Stack>
	</Box>
));
